export default "__VITE_ASSET__DLIMpagz__"